export default __webpack_public_path__ + "static/media/about.68af38a7.svg";